var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('sub-visual', {
    attrs: {
      "tit": "공지사항",
      "sc": "공지사항 서브텍스트가 들어갑니다.",
      "bg": "/images/sub/visual/sv-notice.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [!_vm.$route.params._notification ? _c('notification-list') : _c('notification-view')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }